import script from "./supplierAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./supplierAdd.vue?vue&type=script&setup=true&lang=js"

import "./supplierAdd.vue?vue&type=style&index=0&id=fff84cae&lang=scss&scoped=true"
import "./supplierAdd.vue?vue&type=style&index=1&id=fff84cae&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff84cae"]])

export default __exports__